import { Box, Button, EmptyState } from "@salestrak/ui";

/**
 * The one load-failure empty for settings screens: destructive chip, the noun
 * in the title, the raw error message as the mono detail line, and a retry.
 * A screen renders this when its query errored AND it has nothing cached to
 * show — errors over stale data stay toast-level.
 */
export function LoadErrorState({
  noun,
  error,
  onRetry,
}: {
  noun: string;
  /** `undefined` is a legal explicit value — detail routes gate on a missing
   *  entity and pass whatever error the query may or may not have. */
  error?: { message: string } | null | undefined;
  onRetry?: (() => void) | undefined;
}) {
  return (
    <Box align="center" fill="flex" justify="center">
      <EmptyState
        actions={
          onRetry ? <Button onClick={onRetry}>Try again</Button> : undefined
        }
        detail={error?.message}
        icon="alert-triangle"
        media="icon"
        title={`Unable to load ${noun}`}
        color="destructive"
      />
    </Box>
  );
}
